// extracted by mini-css-extract-plugin
module.exports = {"w740aet":"w740aet"};